/*==========================================================
MAIN NAV SCRIPTS
==========================================================*/

// Options
const mainNavTrigger = 'click', // 'click' or 'hover'
dropdownToggleClass = 'sfHover'; // same class as superfish for CSS consistency between different trigger types

// Elements
let $nav = $('#nav'),
$navItem = $nav.find('> li'),
$navLink = $navItem.find('> a');

$(function() {
  mainNavClick();

  // Configure main nav trigger
  if (mainNavTrigger == 'hover') {
    mainNavHover();
  }

  // Mobile Nav Trigger
  $('.mobileNav').find('.menuTrigger').on('click', function() {
    //add here
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'false' ? 'true' : 'false');
    $('#mainNav').slideToggle().attr('aria-hidden', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');

  });
});


function mainNavClick() {
  $nav.addClass('nav--click');

  $.fn.slideToggleBool = function(bool, options) {
    return bool? $(this).slideDown(options) : $(this).slideUp(options);
  }

  function navCloseDropdown() {
      $navItem.find('.dropDownContainer').slideToggleBool(false, 240).parent('li').removeClass(dropdownToggleClass).find('> a:not(.extendedMenu), .mainNavItem_expander').attr('aria-expanded', false);
  }

  function navClickDropdown(bindClick) {
    $navItem.each(function(index) {
      let $dropdown = $(this).find('.dropDownContainer');

      if ($dropdown.length) {
        let dropdownID = $dropdown.attr('id') ? $dropdown.attr('id') : 'navItemDropdown' + index,
        $dropdownToggleEls = $navItem.eq([index]).find('> a, > .mainNavItem_expander'); 

        $dropdown.attr('id', dropdownID);
        $dropdownToggleEls.attr({
          'aria-controls': dropdownID,
          'aria-expanded': false,
          'aria-haspopup': true
        });

        $navItem.eq([index]).find('> a').attr('role', 'button');

        if (bindClick) {
          $dropdownToggleEls.click(function(event) {
            if ($(this).attr('role') || $(this).is('button')) {
              event.preventDefault();
              event.stopPropagation();
            }

            let wasOpen = $(this).parent('li').find('.dropDownContainer').is(':visible');

            // Close all dropdowns
            $navItem.find('.dropDownContainer').slideToggleBool(false, 240).parent('li').removeClass(dropdownToggleClass).find('> [aria-expanded="true"]').attr('aria-expanded', 'false');
            console.log("closed");

            // Open clicked dropdown if it wasn't just closed
            if (!wasOpen) {
              $(this).parent('li').toggleClass(dropdownToggleClass);
              $dropdown.slideToggleBool(true, 240);
              $dropdownToggleEls.attr('aria-expanded', true);
            }
          });
        }
      }
    });

    if (window.matchMedia('(max-width: 991px)').matches) {
      // Only toggle dropdown with .mainNavItem_expander on mobile
      $navItem.find('> a').removeAttr('role aria-controls aria-expanded aria-haspopup');
    }
  }

  navClickDropdown(true);

  //debounce resize instead of standard resize
  $(window).debounceResize(function() {
    navCloseDropdown();
    navClickDropdown();
  });

  // Close dropdown if clicked outside of it
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.dropDownContainer:visible').length) {
      navCloseDropdown();
    }
  });
}

function mainNavHover() {
  $.getScript('https://js.esolutionsgroup.ca/js/libs/hover-intent/1.8.0/jquery.hoverIntent.min.js', function() {
    $.getScript('https://js.esolutionsgroup.ca/js/libs/jquery_superfish/1.7.4/superfish.min.js', function() {
      $nav.addClass('nav--hover');
      mainNavHoverFn();
    });
  });
}

function mainNavHoverFn() {
  if (window.matchMedia('(max-width: 991px)').matches) {
    $nav.superfish('destroy');
  } else {
    $navItem.removeClass('mobile-open');
    $nav.superfish({
      cssArrows: false,
      speed: 'normal',
      speedOut: 'fast'
    });
  }

  //debounce resize instead of standard resize
  $(window).debounceResize(function() {
    mainNavHoverFn();
  });
}
